import {
  Box,
  Flex,
  Text,
  IconButton,
  Button,
  Stack,
  Collapse,
  Icon,
  Link,
  Popover,
  PopoverTrigger,
  PopoverContent,
  useColorModeValue,
  useBreakpointValue,
  useDisclosure,
  Image,
} from "@chakra-ui/react";
import {
  HamburgerIcon,
  CloseIcon,
  ChevronDownIcon,
  ChevronRightIcon,
} from "@chakra-ui/icons";

export default function Nav({ counterIndex }: { counterIndex: any }) {
  const { isOpen, onToggle } = useDisclosure();

  return (
    <Box>
      <Flex
        rounded={"2xl"}
        bg={useColorModeValue("blacK", "gray.800")}
        color={useColorModeValue("white", "white")}
        minH={"50px"}
        maxW={{ md: "7xl" }}
        py={{ base: 2 }}
        px={{ base: 4 }}
        align={"center"}
      >
        {/* <Flex
          justifyContent={"center"}
          flex={{ md: 1 }}
          ml={{ base: -2 }}
          display={{ base: "flex", md: "none" }}
        > */}
          {/* <IconButton
            onClick={onToggle}
            rounded={"full"}
            border="1px"
            borderColor="gray.500"
            icon={
              isOpen ? <CloseIcon w={3} h={3} /> : <HamburgerIcon w={5} h={5} />
            }
            variant={"ghost"}
            aria-label={"Toggle Navigation"}
          /> */}
        {/* </Flex> */}
        <Flex flex={{ base: 1 }} justify={{ base: "start", md: "start" }}>
          {/* <Text
            textAlign={useBreakpointValue({ base: "center", md: "left" })}
            fontFamily={"heading"}
            color={useColorModeValue("gray.800", "white")}
          > */}
          <Image
            src={
              "https://github.com/Raunaks068619/portfolio_resume/blob/master/src/assets/loogo.png?raw=true"
            }
            maxW={"100px" }
            // width={"100%"}
          />
          {/* </Text> */}

          <Flex display={{ base: "none", md: "flex" }} ml={10}>
            <DesktopNav />
          </Flex>
        </Flex>

        <Stack
          flex={{ base: 1, md: 0 }}
          justify={"flex-end"}
          direction={"row"}
          spacing={6}
        >
          <a href="https://www.linkedin.com/in/raunak-singh-608051218/">
            <Button
              fontSize={"sm"}
              fontWeight={"semibold"}
              color={"black"}
              bgColor={"white"}
              _hover={{
                bgColor: "gray.50",
              }}
              rounded={"xl"}
              textColor={"blue"}
            >
              Linkedin
            </Button>
          </a>
          <a href="https://github.com/Raunaks068619/">
            <Button
              fontSize={"sm"}
              fontWeight={"semibold"}
              color={"black"}
              bgColor={"white"}
              _hover={{
                bgColor: "gray.50",
              }}
              rounded={"xl"}
            >
              Github
            </Button>
          </a>
        </Stack>
      </Flex>

      {/* <Collapse in={isOpen} animateOpacity>
       <MobileNav /> 
      </Collapse> */}
    </Box>
  );
}

const DesktopNav = () => {
  const linkColor = useColorModeValue("gray.600", "gray.200");
  const linkHoverColor = useColorModeValue("gray.800", "white");
  const popoverContentBgColor = useColorModeValue("white", "gray.800");

  return (
    <Stack direction={"row"} spacing={0}>
      {/* {NAV_ITEMS.map((navItem) => (
        <Box key={navItem.label}>
          <Popover trigger={"hover"} placement={"bottom-start"}> */}
      {/* <PopoverTrigger>
              <Link
                _focus={{ boxShadow: "none" }}
                p={2}
                href={navItem.href ?? "#"}
                fontSize={"sm"}
                fontWeight={"semibold"}
                color={"gray.400"} //link color Nav
                _hover={{
                  textDecoration: "none",
                  color: "gray",
                }}
              >
                {navItem.label}
              </Link>
            </PopoverTrigger> */}

      {/* {navItem.children && (
              <PopoverContent
                border={0}
                boxShadow={"xl"}
                bg={popoverContentBgColor}
                p={4}
                rounded={"xl"}
                minW={"md"}
              >
                <Stack>
                  {navItem.children.map((child) => (
                    <DesktopSubNav key={child.label} {...child} />
                  ))}
                </Stack>
              </PopoverContent>
            )} */}
      {/* </Popover>
        </Box>
      ))} */}
    </Stack>
  );
};

// const DesktopSubNav = ({ label, href, subLabel }: NavItem) => {
//   return (
//     <Link
//       href={href}
//       role={"group"}
//       display={"block"}
//       p={2}
//       rounded={"md"}
//       bgColor={"gray.50"}
//       _hover={{
//         bg: useColorModeValue("white", "gray.900"),
//       }}
//     >
//       <Stack direction={"row"} align={"center"}>
//         <Box>
//           <Text
//             transition={"all .3s ease"}
//             textColor={"black"}
//             // _groupHover={{ color: "pink.400" }}
//             fontWeight={500}
//           >
//             {label}
//           </Text>
//           <Text textColor={"gray.500"} fontSize={"sm"}>
//             {subLabel}
//           </Text>
//         </Box>
//         <Flex
//           transition={"all .3s ease"}
//           transform={"translateX(-10px)"}
//           opacity={0}
//           _groupHover={{ opacity: "100%", transform: "translateX(0)" }}
//           justify={"flex-end"}
//           align={"center"}
//           flex={1}
//         >
//           <Icon color={"black"} w={5} h={5} as={ChevronRightIcon} />
//         </Flex>
//       </Stack>
//     </Link>
//   );
// };

const MobileNav = () => {
  return (
    <Stack
      bg={useColorModeValue("white", "gray.800")}
      p={4}
      display={{ md: "none" }}
    >
      {NAV_ITEMS.map((navItem) => (
        <MobileNavItem key={navItem.label} {...navItem} />
      ))}
    </Stack>
  );
};

const MobileNavItem = ({ label, children, href }: NavItem) => {
  const { isOpen, onToggle } = useDisclosure();

  return (
    <div></div>
    // <Stack spacing={4} onClick={children && onToggle}>
    //   <Flex
    //     py={2}
    //     as={Link}
    //     href={href ?? "#"}
    //     justify={"space-between"}
    //     align={"center"}
    //     _hover={{
    //       textDecoration: "none",
    //     }}
    //   >
    //     <Text
    //       fontWeight={"semibold"}
    //       color={useColorModeValue("gray.600", "gray.200")}
    //     >
    //       {label}
    //     </Text>
    //     {children && (
    //       <Icon
    //         as={ChevronDownIcon}
    //         transition={"all .25s ease-in-out"}
    //         transform={isOpen ? "rotate(180deg)" : ""}
    //         w={6}
    //         h={6}
    //       />
    //     )}
    //   </Flex>

    //   <Collapse in={isOpen} animateOpacity style={{ marginTop: "0!important" }}>
    //     <Stack mt={2} pl={4} align={"start"}>
    //       {children &&
    //         children.map((child) => (
    //           <Link key={child.label} py={2} href={child.href}>
    //             {child.label}
    //           </Link>
    //         ))}
    //     </Stack>
    //   </Collapse>
    // </Stack>
  );
};

interface NavItem {
  label: string;
  subLabel?: string;
  children?: Array<NavItem>;
  href?: string;
}

const NAV_ITEMS: Array<NavItem> = [
  {
    label: "Inspiration",
    children: [
      {
        label: "Explore Design Work",
        subLabel: "Trending Design to inspire you",
        href: "#",
      },
      {
        label: "New & Noteworthy",
        subLabel: "Up-and-coming Designers",
        href: "#",
      },
    ],
  },
  {
    label: "Find Work",
    children: [
      {
        label: "Job Board",
        subLabel: "Find your dream design job",
        href: "#",
      },
      {
        label: "Freelance Projects",
        subLabel: "An exclusive list for contract work",
        href: "#",
      },
    ],
  },
  {
    label: "Learn Design",
    href: "#",
  },
  {
    label: "Hire Designers",
    href: "#",
  },
];
